const BannerInfo = () => (
  <div className="alert alert-info" role="alert">
    Upload an order from a CSV template.{" "}
    <a
      href="https://cdn.fashionbiz.com/webstore/FashionBizOrderExport.csv"
      target="_blank"
      rel="noopener noreferrer"
    >
      Click for example template
    </a>
    <br />
    <i>NOTE: Please do not have duplicate SKUs on separate lines of the CSV.</i>
  </div>
);

export default BannerInfo;
